app.filter('address',
    function() {
        return function(address) {
            var fullAddressString = '';
            if(address.city) {
                fullAddressString += address.city;
                fullAddressString += ', ';
            }
            if(address.street) {
                fullAddressString += address.street;
                fullAddressString += ' ';
            }
            if(address.streetNumber) {
                fullAddressString += address.streetNumber;
                fullAddressString += ' ';
            }
            if(address.flatNumber) {
                fullAddressString += '/';
                fullAddressString += address.flatNumber;
            }
            return fullAddressString;
        }
    }
);